import { render } from "./Password.vue?vue&type=template&id=c4c1d132"
import script from "./Password.vue?vue&type=script&lang=js"
export * from "./Password.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./Password.vue?vue&type=style&index=0&id=c4c1d132&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "/home/runner/work/sma-order/sma-order/frontend/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__